import { Badge, type BadgeVariant } from '@/components/ui/badge'
import type { FloristStatus } from '@/lib/services/organizations/organizations.types'
import { BadgeCheck, CircleOff, Globe2, Wrench, type LucideIcon } from 'lucide-react'

type FloristStatusConfig = {
  label: string
  variant: BadgeVariant
  icon: LucideIcon
  /** The Florist Map pin's fill, in the badge's color. */
  pinClassName: string
}

const floristStatusConfig: Record<FloristStatus, FloristStatusConfig> = {
  live: {
    label: 'Live',
    variant: 'success',
    icon: BadgeCheck,
    pinClassName: 'bg-success',
  },
  lost: {
    label: 'Lost',
    variant: 'destructive',
    icon: CircleOff,
    pinClassName: 'bg-destructive',
  },
  needs_setup: {
    label: 'Needs Setup',
    variant: 'muted',
    icon: Wrench,
    pinClassName: 'bg-muted-foreground',
  },
  non_florist: {
    label: 'Non-Florist',
    variant: 'outline',
    icon: Globe2,
    pinClassName: 'bg-muted-foreground',
  },
}

export function getFloristStatusConfig(
  status: FloristStatus | null | undefined
): FloristStatusConfig {
  return status ? floristStatusConfig[status] : floristStatusConfig.needs_setup
}

export function getFloristStatusLabel(status: FloristStatus | null | undefined): string {
  return getFloristStatusConfig(status).label
}

export function FloristStatusBadge({ status }: { status: FloristStatus | null | undefined }) {
  const config = getFloristStatusConfig(status)
  const StatusIcon = config.icon

  return (
    <Badge variant={config.variant}>
      <StatusIcon />
      {config.label}
    </Badge>
  )
}
